module.exports = __webpack_public_path__ + "static/media/clint-mckoy.5b7c1cad.jpg";